// extracted by mini-css-extract-plugin
module.exports = {"root":"accordions-text_root__9YNQ8","accordion":"accordions-text_accordion__4Vu__","title":"accordions-text_title__0SlVu","accordionTitle":"accordions-text_accordionTitle__UdhtT"};